module.exports = parcelRequire.resolve("e2ZWi");